import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import Layout from '../components/layout';
import Title from '../components/title';
import './subscribers.css';
import searchIcon from '../assets/search.svg';
import editIcon from '../assets/edit.svg';
import deleteIcon from '../assets/delete.svg';

const SUBSCRIBERS_PER_PAGE = 4;

const Subscribers = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [id, setId] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [isEditSubscriberOpen, setIsEditSubscriberOpen] = useState(false);

  const fetchSubscribers = async () => {
    const res = await supabase
      .from("Subscribers")
      .select("*");

    setSubscribers(res.data);
  };

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const editSubscriber = (subscriber) => {
    setId(subscriber.id);
    setEditEmail(subscriber.email);
    setIsEditSubscriberOpen(true);
  };

  const updateSubscriber = async (e) => {
    e.preventDefault();

    await supabase
      .from("Subscribers")
      .update({
        email: editEmail,
      })
      .eq('id', id);

    await fetchSubscribers();
    setIsEditSubscriberOpen(false);
  };

  const deleteSubscriber = async (id) => {
    await supabase.from("Subscribers").delete().eq('id', id);
    await fetchSubscribers();
  };

  const filteredSubscribers = subscribers.filter((subscriber) => {
    const value = searchTerm.toLowerCase();

    const matchesSearch = (
      subscriber.id.toString().includes(value) ||
      subscriber.email.toLowerCase().includes(value)
    );

    return matchesSearch;
  });

  const totalPages = Math.max(1, Math.ceil(filteredSubscribers.length / SUBSCRIBERS_PER_PAGE));
  const startIndex = (currentPage - 1) * SUBSCRIBERS_PER_PAGE;
  const paginatedSubscribers = filteredSubscribers.slice(startIndex, startIndex + SUBSCRIBERS_PER_PAGE);

  return (
    <Layout>
      <div className="subscribers_page">
        <Title
          subtitle="Manage all subscribers on the Eventra platform"
          title="SUBSCRIBERS MANAGEMENT"
        />

        <div className="subscribers_controls_card">
          <div className="subscribers_controls_left">
            <label className="subscribers_search" htmlFor="subscribers-search">
              <img alt="" src={searchIcon} />
              <input
                id="subscribers-search"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder="Search subscribers..."
                value={searchTerm}
              />
            </label>
          </div>
        </div>

        <div className="subscribers_table_card">
          <div className="subscribers_table_top">
            <div className="subscribers_table_title">All Subscribers</div>
            <div className="subscribers_table_count">{filteredSubscribers.length} total subscribers</div>
          </div>

          <div className="subscribers_table_scroll">
            <div className="subscribers_row subscribers_table_head">
              <div className="subscribers_checkbox">
                <input type="checkbox" />
              </div>
              <div>ID</div>
              <div>Created At</div>
              <div>Email</div>
              <div>Actions</div>
            </div>

            <div className="subscribers_table_body">
              {paginatedSubscribers.map((subscriber) => (
                <div className="subscribers_row" key={subscriber.id}>
                  <div className="subscribers_checkbox">
                    <input type="checkbox" />
                  </div>

                  <div className="subscribers_cell_text">{subscriber.id}</div>
                  <div className="subscribers_cell_text">{subscriber.created_at}</div>
                  <div className="subscribers_cell_text">{subscriber.email}</div>

                  <div className="subscribers_actions">
                    <button
                      className="subscribers_action_button"
                      onClick={() => editSubscriber(subscriber)}>
                      <img alt="" src={editIcon} />
                    </button>
                    <button className="subscribers_action_button" onClick={() => deleteSubscriber(subscriber.id)}>
                      <img alt="" src={deleteIcon} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="subscribers_pagination">
            <button
              className="subscribers_pagination_button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Previous
            </button>
            <div className="subscribers_pagination_info">
              Page {currentPage} of {totalPages}
            </div>
            <button
              className="subscribers_pagination_button"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>

        {isEditSubscriberOpen && (
          <div
            className="subscribers_modal_overlay"
            onClick={() => setIsEditSubscriberOpen(false)}
          >
            <div
              className="subscribers_modal"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="subscribers_modal_header">
                <div className="subscribers_modal_heading">
                  <h2>EDIT SUBSCRIBER</h2>
                  <p>Update the subscriber details below.</p>
                </div>

                <button
                  className="subscribers_modal_close"
                  onClick={() => setIsEditSubscriberOpen(false)}>
                  x
                </button>
              </div>

              <form
                className="subscribers_modal_form"
                onSubmit={updateSubscriber}
              >
                <div className="subscribers_modal_grid">
                  <label className="subscribers_modal_field">
                    <span>Email</span>
                    <input
                      onChange={(e) => setEditEmail(e.target.value)}
                      value={editEmail}
                    />
                  </label>
                </div>

                <div className="subscribers_modal_actions">
                  <button
                    className="subscribers_modal_secondary_button"
                    onClick={() => setIsEditSubscriberOpen(false)}>
                    Cancel
                  </button>
                  <button className="subscribers_modal_primary_button">
                    Update Subscriber
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Subscribers;
